import React, { useEffect, useRef } from 'react';
import { API_GATEWAY_URL, CLOCK_WIDGET_URL } from '../config';
import api from '../services/api';

// The widget's code lives in attendance-service (client/widget) and is loaded at
// runtime, so fixes deployed there show up here without a rebuild.
const ClockWidgetMount = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (!CLOCK_WIDGET_URL || document.querySelector('script[data-clock-widget]')) return;
    const script = document.createElement('script');
    script.src = CLOCK_WIDGET_URL;
    script.async = true;
    script.dataset.clockWidget = '';
    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    // Any call through the app's axios instance runs the shared 401 → refresh flow.
    if (ref.current) ref.current.refreshToken = () => api.get(`${API_GATEWAY_URL}/attendance-service/clock/current`);
  }, []);

  if (!CLOCK_WIDGET_URL) return null;

  return <anyemp-clock-widget ref={ref} gateway-url={API_GATEWAY_URL} />;
};

export default ClockWidgetMount;
